const propertiesCountryButton = document.querySelector('.properties__country__tag__button');

if (propertiesCountryButton) {
    propertiesCountryButton.addEventListener('click', () => {
        document.querySelector('.properties__country__tag').classList.toggle('active');
    });
}

const swiperPropertiesCountry = new Swiper(".properties__country__slider", {
    loop: false,
    spaceBetween: 0,
    slidesPerView: 'auto',
    speed: 800,
    navigation: {
        nextEl: ".properties__country-next",
        prevEl: ".properties__country-prev",
    },
    pagination: {
        el: ".properties__country-pagination",
        clickable: true,
    },
});

const tagPropertiesBlock = document.querySelector('.properties__country__tag');

const filterSlides = (filterValue, activeButton = null) => {
    const slides = document.querySelectorAll('.properties__country__slider .swiper-slide');
    const swiperEl = document.querySelector('.properties__country__slider.swiper');
    const swiper = swiperEl?.swiper;
    
    slides.forEach(slide => {
        const slideValue = slide.getAttribute('data-slide');
        if (filterValue === 'all' || slideValue === filterValue) {
            slide.style.display = '';
        } else {
            slide.style.display = 'none';
        }
    });
    
    if (swiper && typeof swiper.update === 'function') {
        swiper.update();
        swiper.slideTo(0);
    }

    if (activeButton) {
        const buttons = tagPropertiesBlock.querySelectorAll('[data-button]');
        buttons.forEach(btn => btn.classList.remove('active'));
        activeButton.classList.add('active');
    }
};

if (tagPropertiesBlock) {
    const activeButton = tagPropertiesBlock.querySelector('[data-button].active');
    
    if (activeButton) {
        const filterValue = activeButton.getAttribute('data-button');
        filterSlides(filterValue);
    }
    
    const buttons = tagPropertiesBlock.querySelectorAll('[data-button]');
    
    buttons.forEach(button => {
        button.addEventListener('click', event => {
            event.preventDefault();
            
            const filterValue = button.getAttribute('data-button');
            filterSlides(filterValue, button);
        });
    });
}